import { CommonState, ListParams, Pagination } from './common';
import { TIntention } from './intentions';
import { Images } from './photo';

export enum BannerPlatform {
  ANDROID = 'android',
  HUAWEI = 'huawei',
  IOS = 'ios',
  WEB_DESKTOP = 'web-desktop',
  WEB_MOBILE = 'web-mobile',
}

export type Banner = {
  created_at: string | null;
  active: boolean;
  id: 1;
  images: Images;
  sort: number | null;
  text: string;
  title: string;
  updated_at: string | null;
  button: string | null;
  intention: TIntention | null;
  button_color: string | null;
  button_text_color: string | null;
  badge: string | null;
  platforms: BannerPlatform[];
};

export type BannerList = {
  data?: Banner[];
  meta?: Pagination;
};

export type BannerListParams = ListParams;

export type BannerState = CommonState & {
  bannerList: BannerList;
  bannerListParams: BannerListParams;
  banner: Banner | null;
};

export type ParamsBannerForForm = Omit<Banner, 'id' | 'sort' | 'created_at' | 'updated_at'>;

export type ParamMassBannerSort = { id: number; sort: number | null };
